<!-- 考试分数 -->
<template>
  <div class="exam-score">
    <h1 class="application-title">考试分数</h1>
    <div class="application-smart-title">
      Test Scores
    </div>
    <div class="application-smart-light-title">
      如果尚未完成或者正在进行语言考试，可在成绩出来之后再补齐
    </div>
    <div class="exam-score-form">
      <Form ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate"
            :label-width="226">
        <div class="exam-score-form-item-small">
          <FormItem label="GRE Test Date"
                    prop="greDate">
            <DatePicker type="date"
                        placeholder="Select date"
                        v-model="formValidate.greDate"
                        style="width:100%;"></DatePicker>
          </FormItem>
          <FormItem label="GRE Total"
                    prop="greScore">
            <Input v-model="formValidate.greScore"
                   placeholder="e.g. 330"></Input>

          </FormItem>
        </div>
        <div class="exam-score-form-item-small">
          <FormItem label="GRE Quant"
                    prop="greQuant">
            <Input v-model="formValidate.greQuant"
                   placeholder="e.g. 170"></Input>
          </FormItem>
          <FormItem label="GRE Quant %"
                    prop="greQuantPercentile">
            <Input v-model="formValidate.greQuantPercentile"
                   placeholder="e.g. 100%"></Input>
          </FormItem>
          <FormItem label="GRE Verbal"
                    prop="greVerbal">
            <Input v-model="formValidate.greVerbal"
                   placeholder="e.g. 160"></Input>
          </FormItem>
          <FormItem label="GRE Verbal %"
                    prop="greVerbalPercentile">
            <Input v-model="formValidate.greVerbalPercentile"
                   placeholder="e.g. 94%"></Input>
          </FormItem>
          <FormItem label="GRE Analytical Writing"
                    prop="greWriting">
            <Input v-model="formValidate.greWriting"
                   placeholder="e.g. 5.0"></Input>
          </FormItem>
          <FormItem label="GRE Analytical Writing %"
                    prop="greWritingPercentile">
            <Input v-model="formValidate.greWritingPercentile"
                   placeholder="e.g. 83%"></Input>
          </FormItem>
        </div>
        <div class="exam-score-form-item">
          <FormItem label="GRE Sub"
                    prop="greSub">
            <Input v-model="formValidate.greSub"
                   placeholder="e.g. 970"></Input>
          </FormItem>
        </div>
        <div class="exam-score-form-item-small">
          <FormItem label="GMAT Test Date"
                    prop="gmatDate">
            <DatePicker type="date"
                        placeholder="Select date"
                        v-model="formValidate.gmatDate"
                        style="width:100%;"></DatePicker>
          </FormItem>
          <FormItem label="GMAT Total"
                    prop="gmatTotal">
            <Input v-model="formValidate.gmatTotal"
                   placeholder="e.g. 330"></Input>
          </FormItem>
        </div>
        <div class="exam-score-form-item">
          <FormItem label="GMAT Quant"
                    prop="gmatQuant">
            <Input v-model="formValidate.gmatQuant"
                   placeholder="e.g. 170"></Input>
          </FormItem>
          <FormItem label="GMAT Quant %"
                    prop="gmatQuantPercentile">
            <Input v-model="formValidate.gmatQuantPercentile"
                   placeholder="e.g. 100%"></Input>
          </FormItem>
          <FormItem label="GMAT Verbal"
                    prop="gmatVerbal">
            <Input v-model="formValidate.gmatVerbal"
                   placeholder="e.g. 60"></Input>
          </FormItem>
          <FormItem label="GMAT Verbal %"
                    prop="gmatVerbalPercentile">
            <Input v-model="formValidate.gmatVerbalPercentile"
                   placeholder="e.g. 94%"></Input>
          </FormItem>
          <FormItem label="GMAT Analytical Writing"
                    prop="gmatAW">
            <Input v-model="formValidate.gmatAW"
                   placeholder="e.g. 5.0"></Input>
          </FormItem>
          <FormItem label="GMAT Analytical Writing %"
                    prop="gmatAWPercentile">
            <Input v-model="formValidate.gmatAWPercentile"
                   placeholder="e.g. 83%"></Input>
          </FormItem>
          <FormItem label="GMAT Integrated Reasoning"
                    prop="gmatIR">
            <Input v-model="formValidate.gmatIR"
                   placeholder="e.g. 8"></Input>
          </FormItem>
          <FormItem label="GMAT Integrated Reasoning % "
                    prop="gmatIRPercentile">
            <Input v-model="formValidate.gmatIRPercentile"
                   placeholder="e.g. 76%"></Input>
          </FormItem>
        </div>
        <div class="exam-score-form-item-small">
          <FormItem label="TOEFL Test Date"
                    prop="toeflDate">
            <DatePicker type="date"
                        placeholder="Select date"
                        v-model="formValidate.toeflDate"
                        style="width:100%;"></DatePicker>
          </FormItem>
          <FormItem label="Score"
                    prop="toeflScore">
            <Input v-model="formValidate.toeflScore"
                   placeholder="e.g. 115"></Input>
          </FormItem>
        </div>
        <div class="exam-score-form-item">
          <FormItem label="Reading"
                    prop="toeflReading">
            <Input v-model="formValidate.toeflReading"
                   placeholder="e.g. 30"></Input>
          </FormItem>
          <FormItem label="Listening"
                    prop="toeflListening">
            <Input v-model="formValidate.toeflListening"
                   placeholder="e.g. 30"></Input>
          </FormItem>
          <FormItem label="Speaking"
                    prop="toeflSpeaking">
            <Input v-model="formValidate.toeflSpeaking"
                   placeholder="e.g. 28"></Input>
          </FormItem>
          <FormItem label="Writing"
                    prop="toeflWriting">
            <Input v-model="formValidate.toeflWriting"
                   placeholder="e.g. 27"></Input>
          </FormItem>
        </div>
        <div class="exam-score-form-item-small">
          <FormItem label="IELTS Test Date"
                    prop="ieltsDate">
            <DatePicker type="date"
                        placeholder="Select date"
                        v-model="formValidate.ieltsDate"
                        style="width:100%;"></DatePicker>
          </FormItem>
          <FormItem label="Score"
                    prop="ieltsScore">
            <Input v-model="formValidate.ieltsScore"
                   placeholder="e.g. 115"></Input>
          </FormItem>
        </div>
        <div class="exam-score-form-item">
          <FormItem label="Reading"
                    prop="ieltsReading">
            <Input v-model="formValidate.ieltsReading"
                   placeholder="e.g. 30"></Input>
          </FormItem>
          <FormItem label="Listening"
                    prop="ieltsListening">
            <Input v-model="formValidate.ieltsListening"
                   placeholder="e.g. 30"></Input>
          </FormItem>
          <FormItem label="Speaking"
                    prop="ieltsSpeaking">
            <Input v-model="formValidate.ieltsSpeaking"
                   placeholder="e.g. 28"></Input>
          </FormItem>
          <FormItem label="Writing"
                    prop="ieltsWriting">
            <Input v-model="formValidate.ieltsWriting"
                   placeholder="e.g. 27"></Input>
          </FormItem>
        </div>
        <div>
          <FormItem label="Plans to retake any test"
                    prop="planToRetake">
            <DatePicker type="date"
                        placeholder="Select date"
                        v-model="formValidate.planToRetake"
                        style="width:100%;"></DatePicker>
          </FormItem>
          <FormItem label="Any other scores - LSAT"
                    prop="otherScore1">
            <Input v-model="formValidate.otherScore1"
                   placeholder="e.g. 175"></Input>
          </FormItem>
          <FormItem label="Any other scores - MCAT"
                    prop="otherScore2">
            <Input v-model="formValidate.otherScore2"
                   placeholder="e.g. 96%"></Input>
          </FormItem>
        </div>
        <div class="sub-btn" v-if="isallowedit">
          <Affix :offset-bottom="20">
            <Button type="primary"
                    style="width:96px;"
                    @click="saveHandle">保存</Button>
          </Affix>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import isAllowEdit from '@/view/mixins/is-edit'
//  api
import { infoQueryScore, infoModifyScore } from '@/api/info'
// tool
import { date2String } from '@/libs/tools'
import { validateNumber, validatePercent, validateFloat, validateRange, validateMultiple } from '@/libs/validator'
export default {
  name: 'application-exam-score',
  components: {},
  mixins: [isAllowEdit],
  data () {
    return {
      formValidate: {},
      ruleValidate: {
        greScore: [{ validator: validateNumber, minNum: 260, maxNum: 340 }],
        greQuant: [{ validator: validateNumber, minNum: 130, maxNum: 170 }],
        greQuantPercentile: [{ validator: validatePercent, minNum: 0, maxNum: 100 }],
        greVerbal: [{ validator: validateNumber, minNum: 130, maxNum: 170 }],
        greVerbalPercentile: [{ validator: validatePercent, minNum: 0, maxNum: 100 }],
        greWriting: [{ validator: validateFloat }, { validator: validateRange, minNum: 0, maxNum: 6 }],
        greWritingPercentile: [{ validator: validatePercent, minNum: 0, maxNum: 100 }],
        greSub: [{ validator: validateNumber, minNum: 220, maxNum: 990 }],
        gmatTotal: [{ validator: validateNumber, minNum: 220, maxNum: 800 }, { validator: validateMultiple, multiple: 10 }],
        gmatQuant: [{ validator: validateNumber, minNum: 0, maxNum: 60 }],
        gmatQuantPercentile: [{ validator: validatePercent, minNum: 0, maxNum: 100 }],
        gmatVerbal: [{ validator: validateNumber, minNum: 0, maxNum: 60 }],
        gmatVerbalPercentile: [{ validator: validatePercent, minNum: 0, maxNum: 100 }],
        gmatAW: [{ validator: validateFloat }, { validator: validateRange, minNum: 0, maxNum: 6 }],
        gmatAWPercentile: [{ validator: validatePercent, minNum: 0, maxNum: 100 }],
        gmatIR: [{ validator: validateNumber, minNum: 0, maxNum: 8 }],
        gmatIRPercentile: [{ validator: validatePercent, minNum: 0, maxNum: 100 }],
        toeflScore: [{ validator: validateNumber, minNum: 0, maxNum: 120 }],
        toeflReading: [{ validator: validateNumber, minNum: 0, maxNum: 30 }],
        toeflListening: [{ validator: validateNumber, minNum: 0, maxNum: 30 }],
        toeflSpeaking: [{ validator: validateNumber, minNum: 0, maxNum: 30 }],
        toeflWriting: [{ validator: validateNumber, minNum: 0, maxNum: 30 }],
        ieltsScore: [{ validator: validateFloat }, { validator: validateRange, minNum: 0, maxNum: 9 }, { validator: validateMultiple, multiple: 0.5 }],
        ieltsReading: [{ validator: validateFloat }, { validator: validateRange, minNum: 0, maxNum: 9 }, { validator: validateMultiple, multiple: 0.5 }],
        ieltsListening: [{ validator: validateFloat }, { validator: validateRange, minNum: 0, maxNum: 9 }, { validator: validateMultiple, multiple: 0.5 }],
        ieltsSpeaking: [{ validator: validateFloat }, { validator: validateRange, minNum: 0, maxNum: 9 }, { validator: validateMultiple, multiple: 0.5 }],
        ieltsWriting: [{ validator: validateFloat }, { validator: validateRange, minNum: 0, maxNum: 9 }, { validator: validateMultiple, multiple: 0.5 }],
        otherScore1: [{ validator: validateNumber, minNum: 120, maxNum: 180 }],
        otherScore2: [{ validator: validateNumber, minNum: 0, maxNum: 528 }]
      }
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      infoQueryScore().then(res => {
        let data = res.data.model || {}
        this.formValidate = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    saveHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          data.planToRetake = date2String(data.planToRetake)
          infoModifyScore(data).then(res => {
            this.$zlr_message('保存成功', 'success')
            this.$router.push({
              name: 'application-experience'
            })
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
